import { Component, Vue } from 'vue-property-decorator';
import { SsoProviderService } from '@/services/sso-service';

@Component({})
export default class ConnectLogin extends Vue {

    async mounted() {
        const queryParam = this.$route.query.ReturnUrl;
        const queryReturnUrl = Array.isArray(queryParam) ? queryParam[0] : queryParam;

        if (!queryReturnUrl) {
            this.goToLoginPage('');

            return;
        }

        const result = await SsoProviderService.login({
            returnUrl: queryParam
        });

        Vue.$sessionStorage.setItem('ssoResult', JSON.stringify(result));
        this.goToLoginPage(queryReturnUrl);
    }

    goToLoginPage(returnUrl) {
        this.$router.push({ name: 'login', query: { ReturnUrl: returnUrl } });
    }
}
